module.exports = __webpack_public_path__ + "img/logo_2.d21a9d9b.jpg";